import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { graphQLQueries } from 'javascripts/shared/graphql/queries';
import { useGraphQLClientData } from 'javascripts/hooks/use-graphql-client-data';
import { Loader } from 'javascripts/components/loader';

import { CollectionCard } from 'javascripts/components/collection_card';

import styles from 'stylesheets/components/category_collections_shelf';

export function CategoryCollectionsShelf({ tagSlug, trackingCategory, linkHref, onDataLoad, trackingProperties }) {
  const { loading, tag: { collections = [] } = {} } = useGraphQLClientData(graphQLQueries.tagCollections, {
    slug: tagSlug,
  });

  useEffect(() => {
    if (!loading) {
      onDataLoad(!_.isEmpty(collections));
    }
  }, [loading]);

  if (loading) {
    return <Loader />;
  }

  if (_.isEmpty(collections)) {
    return null;
  }

  return (
    <div className={styles.categoryCollectionsShelf}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.title}>Book Lists</h2>
        {_.isEmpty(linkHref) ? null : (
          <a className={styles.headerLink} href={linkHref}>
            View All
          </a>
        )}
      </div>
      <div className={styles.collections}>
        {collections.map(collection => {
          return (
            <div className={styles.collection} key={collection.id} data-testid='related-collection'>
              <CollectionCard
                collection={collection}
                lazy
                size='compact'
                showBylineAndDate={false}
                trackingCategory={trackingCategory}
                trackingProperties={trackingProperties}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

CategoryCollectionsShelf.propTypes = {
  tagSlug: PropTypes.string.isRequired,
  trackingCategory: PropTypes.string.isRequired,
  linkHref: PropTypes.string,
  onDataLoad: PropTypes.func,
  trackingProperties: PropTypes.object,
};

CategoryCollectionsShelf.defaultProps = {
  onDataLoad: _.noop,
};
